import { Border } from "./Borders";
import { BoxShadow } from "./BoxShadow";
import { devices, sizes, deviceValue } from "./Breakpoints";
import { Colors } from "./Colors";
import { FlexboxGrid } from "./FlexboxGrid";
import { IconsSize } from "./IconsSize";
import { IconsSizeWithBg } from "./IconsSize";
import { Radius } from "./Radius";
import { Spacing } from "./Spacing";
import { Typography } from "./Typography";
import { WidgetHeight } from "./WidgetHeight";

const Theme = {
    // COLORS
    color: Colors,

    // RADIUS
    radius: Radius,

    // BORDERS
    border: Border,

    // BOX SHADOW
    shadow: BoxShadow,

    // SPACING
    spacing: Spacing,

    // TYPOGRAPHY
    typography:Typography,

    // BREAKPOINTS
    devices: devices,
    deviceSize: sizes,
    deviceValue: deviceValue,

    // FLEXBOXGRID
    flexboxgrid: FlexboxGrid,

    // ICONS
    icons: IconsSize,
    iconsWithBg: IconsSizeWithBg,
    widgetHeight: WidgetHeight
}

export default Theme;